import React, { lazy, Suspense } from "react";

import { Router, Switch, useRouteMatch } from "react-router-dom";
import MovileInventory from "../components/core/inventory/inventories/MovileInventory";
import AccesoryInventory from "../components/core/inventory/inventories/AccesoryInventory";
import ChipInventory from "../components/core/inventory/inventories/ChipInventory";

import StepperInventory from "../components/core/inventory/StepperInventory";
import ContainerGuaranteesAdmin from "../containers/ContainerGuaranteesAdmin";
import Site from "../components/core/sites/Site";
import User from "../components/core/user/User";
import history from "../history";
import ContainerProductDetail from "../containers/ContainerProductDetail";
import SiteDetail from "../components/core/sites/SiteDetail";
import PrivateRoute from "../components/shared/PrivateRoute";
import { Role } from "../_utils/roleEnum";
import MainDashboard from "../components/core/dashboard/MainDashboard";
import MovileInventoryBySite from "../components/core/inventory/inventories/MovileInventoryBySite";
import AccesoryInventoryBySite from "../components/core/inventory/inventories/AccesoryInventoryBySite";
import ChipInventoryBySite from "../components/core/inventory/inventories/ChipInventoryBySite";
import ContainerGuaranteeDetail from "../containers/ContainerGuaranteeDetail";
import NewGuarantee from "../components/core/guarantee/NewGuarantee";
import GuaranteeServiceTicket from "../components/core/guarantee/GuaranteeServiceTicket";
import ContainerProductDetailBySite from "../containers/ContainerProductDetailBySite";
import ContainerShoppingCart from "../containers/ContainerShoppingCart";
import ContainersGuaranteesInSite from "../containers/ContainersGuaranteesInSite";
import ContainerNewSell from "../containers/sells/ContainerNewSell";
import ContainerSells from "../containers/ContainerSells";
import ContainerDisitributionsBySite from "../containers/ContainerDistributionsBySite";
import ContainerProductComparative from "../containers/ContainerProductComparative";
import ContainerGlobalSells from "../containers/sells/ContainerGlobalSells";
import CashCardInventory from "../components/core/inventory/inventories/CashCardInventory";
import CashCardInventoryBySite from "../components/core/inventory/inventories/CashCardInventoryBySite";
import RechargeInventoryBySIte from "../components/core/inventory/inventories/RechargeInventoryBySIte";
import PlanInventoryBySIte from "../components/core/inventory/inventories/PlanInventoryBySIte";
import ContainerExpensesBySite from "../containers/ContainerExpensesBySite";
import ContainerExpense from "../containers/ContainerExpense";
import DistributionByCodeBar from "../components/core/distribution/DistributionByCodeBar";

const GlobalDistributions = lazy(() =>
  import("../components/core/distribution/GlobalDistributions")
);

const Index = () => {
  const { path, url } = useRouteMatch();
  const customContainerSells = () => (
    <ContainerSells title="Mis ventas" typeOfSells="sellsByUser" />
  );
  const customContainerTotalSells = () => (
    <ContainerSells title="Ventas totales" typeOfSells="sellsBySite" />
  );

  return (
    <Suspense fallback={<h2>Cargando...</h2>}>
      <Router history={history}>
        <Switch>
          <PrivateRoute
            roles={[
              Role.Admin,
              Role.ManagerAccesory,
              Role.ManagerMovile,
              Role.Seller,
            ]}
            exact
            path={`${path}`}
            component={MainDashboard}
          />

          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            exact
            path={`${url}/inventario/moviles`}
            component={MovileInventory}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            path={`${url}/inventario/accesorios`}
            exact
            component={AccesoryInventory}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            exact
            path={`${url}/inventario/chips`}
            component={ChipInventory}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            exact
            path={`${url}/inventario/tarjetas-saldo`}
            component={CashCardInventory}
          />
          <PrivateRoute
            roles={[Role.Admin]}
            path={`${url}/inventario/distribucion`}
            component={GlobalDistributions}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            path={`${url}/inventario/captura`}
            component={StepperInventory}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            exact
            path={`${url}/inventario/detalle-producto`}
            component={ContainerProductDetail}
          />
          <PrivateRoute
            roles={[Role.Admin]}
            path={`${url}/inventario/comparativo`}
            component={ContainerProductComparative}
          />

          <PrivateRoute
            roles={[Role.Admin]}
            path={`${url}/ventas`}
            component={ContainerGlobalSells}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.GuaranteeHelper]}
            path={`${url}/garantias`}
            component={ContainerGuaranteesAdmin}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            exact
            path={`${url}/sucursales`}
            component={Site}
          />
          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            path={`${url}/sucursales/id/:id`}
            component={SiteDetail}
          />

          <PrivateRoute
            roles={[Role.Admin]}
            path={`${url}/usuarios`}
            component={User}
          />

          <PrivateRoute
            roles={[Role.Admin]}
            path={`${url}/gastos`}
            component={ContainerExpense}
          />

          <PrivateRoute
            roles={[Role.Admin, Role.ManagerAccesory, Role.ManagerMovile]}
            path={`${url}/distribucion-global`}
            component={DistributionByCodeBar}
          />

          {/** Seller router */}
          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/nueva-venta`}
            component={ContainerNewSell}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/mis-ventas`}
            component={customContainerSells}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/ventas/sucursal`}
            component={customContainerTotalSells}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/moviles/sucursal`}
            component={MovileInventoryBySite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/accesorios/sucursal`}
            component={AccesoryInventoryBySite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/sucursal/detalle-producto`}
            component={ContainerProductDetailBySite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/chips/sucursal`}
            component={ChipInventoryBySite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/tarjetas-saldo/sucursal`}
            component={CashCardInventoryBySite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/traspasos/sucursal`}
            component={RechargeInventoryBySIte}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/planes/sucursal`}
            component={PlanInventoryBySIte}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/garantias`}
            component={ContainersGuaranteesInSite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/distribuciones/sucursal`}
            component={ContainerDisitributionsBySite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/gastos/sucursal`}
            component={ContainerExpensesBySite}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            exact
            path={`${url}/inventario/nueva-garantia`}
            component={NewGuarantee}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            exact
            path={`${url}/inventario/nueva-garantia/service-ticket/:id`}
            component={GuaranteeServiceTicket}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/garantia/:id`}
            component={ContainerGuaranteeDetail}
          />

          <PrivateRoute
            roles={[Role.Seller]}
            path={`${url}/inventario/carrito`}
            component={ContainerShoppingCart}
          />
        </Switch>
      </Router>
    </Suspense>
  );
};

export default Index;
